import { Button, Form } from 'react-bootstrap';
import SelectInput from '../../Misc/SelectInput/SelectInput.jsx';
import CookiesService from '../../../services/cookies.js';


const FilterForm = ({
    filterObj,
    handleSetFilterObj,
    handleFilterButtonClick,
    statusOptions,
    isRevisorView,
    setIsRevisorView,
    styles
}) => {

    const userSupplierPitagoras = CookiesService.getUserSupplierPitagoras();

    return (
        <div className={styles.whiteBox}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginLeft: '-2px' }}>
                <h3 className="p-3">Revisão de Matéria Prima</h3>
                {userSupplierPitagoras ? null :
                    <Button
                        className={styles.toggleViewBtn}
                        type="button"
                        onClick={() => setIsRevisorView(prev => !prev)}
                    >
                        {isRevisorView ? 'MUDAR PARA VISÃO AUDITOR' : 'MUDAR PARA VISÃO REVISOR'}
                    </Button>
                }
            </div>
            <Form className={styles.filterFormWrapper}>
                <Form.Group className={styles.filterInputGroup}>
                    <Form.Label className={styles.filterLabel}>Pedido</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder={'Pedido'}
                        className={styles.filterInput}
                        value={filterObj.pedido || ''}
                        onChange={e => handleSetFilterObj('pedido', e.target.value)}
                        style={{ width: 'inherit' }}
                    />
                </Form.Group>
                <Form.Group className={styles.filterInputGroup}>
                    <Form.Label className={styles.filterLabel}>Material</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder={'Material'}
                        className={styles.filterInput}
                        value={filterObj.material || ''}
                        onChange={e => handleSetFilterObj('material', e.target.value)}
                        style={{ width: 'inherit' }}
                    />
                </Form.Group>
                <Form.Group className={styles.filterInputGroup}>
                    <Form.Label className={styles.filterLabel}>Cor</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder={'Cor'}
                        className={styles.filterInput}
                        value={filterObj.corMaterial || ''}
                        onChange={e => handleSetFilterObj('corMaterial', e.target.value)}
                        style={{ width: 'inherit' }}
                    />
                </Form.Group>
                <Form.Group className={styles.filterInputGroup}>
                    <Form.Label className={styles.filterLabel}></Form.Label>
                    <SelectInput
                        placeholder={'Status'}
                        label={'Status'}
                        options={statusOptions}
                        value={filterObj.statusRevisao ? { value: filterObj.statusRevisao, label: filterObj.statusRevisao } : null}
                        onChange={opt => handleSetFilterObj('statusRevisao', opt ? opt.value : '')}
                        isClearable={true}
                        style={{ width: 'auto' }}
                    />
                </Form.Group>
                <Button
                    type="button"
                    className={styles.filterBtn}
                    onClick={handleFilterButtonClick}
                >
                    Filtrar
                </Button>
            </Form>
        </div>
    );
};

export default FilterForm;